// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select[data-v-d9f4c844]{-webkit-appearance:none;-moz-appearance:none;appearance:none}
`, "",{"version":3,"sources":["webpack://./src/components/form-select/FormSelect.vue"],"names":[],"mappings":"AACI,gCACI,uBAAwB,CACxB,oBAAqB,CACrB,eAAgB","sourcesContent":["\n    .custom-select {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
